"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AdminDropdownButton", {
    enumerable: true,
    get: function() {
        return AdminDropdownButton;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Dropdown = require("../Dropdown");
const _DropdownMenu = require("../DropdownMenu/DropdownMenu");
const _AdminDropdownToggle = require("../DropdownToggle/AdminDropdownToggle");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const AdminDropdownButton = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, placement = "bottom-start", onSelect, flip = true, dropdownTitle, supportsMobile, title, fixedHeader, ...props } = param;
    return /*#__PURE__*/ _react.default.createElement(_Dropdown.Dropdown, {
        placement: placement,
        onSelect: onSelect,
        flip: flip
    }, /*#__PURE__*/ _react.default.createElement(_AdminDropdownToggle.AdminDropdownToggle, {
        ...props,
        ref: ref
    }, title), /*#__PURE__*/ _react.default.createElement(_DropdownMenu.DropdownMenu, {
        title: dropdownTitle,
        mobileView: supportsMobile === true ? "full" : undefined,
        fixedHeader: fixedHeader
    }, children));
});
AdminDropdownButton.displayName = "DropdownButton";

//# sourceMappingURL=AdminDropdownButton.js.map